module.exports = __webpack_public_path__ + "static/img/histoire-05.447fe90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/histoire-05.png
// module id = 90
// module chunks = 0